<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row>
          <b-col cols="12" md="3" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" md="auto" class="mt-2 mt-sm-0 ml-auto">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
           
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Statement Date"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datestatement"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="From"
                      :disabled="false"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datestatement || source != 'saracs_live'"
                        @click="datestatement = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Account Type"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select type..."
                    v-model="accounttype"
                    :clearable="true"
                    :multiple="true"
                    :options="accounttype_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect
                    v-model="status"
                    :clearable="true"
                    :options="status_options"
                  ></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label="Statement Type"
                  label-cols="12"
                  label-size="sm"
                >
                  <treeselect
                    v-model="statementtype"
                    :clearable="true"
                    :multiple="true"
                    :options="statementtype_options"
                  ></treeselect>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" md="auto">
                  <i
                    id="database"
                    :class="
                      busy
                        ? 'fa fa-database text-danger mt-2 ml-2 mr-1'
                        : 'fa fa-database text-primary mt-2 ml-2 mr-1'
                    "
                  ></i>
                </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Statement from"
                  label-size="sm"
                >
                  <treeselect
                    v-model="source"
                    :options="source_options"
                    :clearable="false"
                  ></treeselect>
                </b-form-group>
                <b-tooltip target="database" triggers="hover"
                  >The active datasource</b-tooltip
                >
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group
                  label-cols="12"
                  label="Transaction Date"
                  label-size="sm"
                >
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker
                      size="sm"
                      ref="transactiondate"
                      v-model="transactiondate"
                      :opens="'right'"
                      :locale-data="locale_data"
                      :ranges="locale_ranges"
                      :showDropdowns="true"
                      :linkedCalendars="true"
                      :single-date-picker="'range'"
                    >
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="
                          transactiondate = {
                            startDate: null,
                            endDate: null,
                          }
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Query" label-size="sm">
                  <treeselect
                    v-model="query"
                    :clearable="false"
                    :options="query_options"
                  ></treeselect>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date From"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datefrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="From"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datefrom"
                        @click="datefrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Transaction Date To"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="dateto"
                      label-help
                      hide-header
                      placeholder="To"
                      locale="en-GB"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!dateto"
                        @click="dateto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                    class="gridtoolbar"
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in options.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :options="tool.options"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                :sticky-header="btable_height + 'px'"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                foot-clone
                no-footer-sorting
                :busy="btable_busy"
                :items="btable_items"
                :fields="options.fields"
                :filter="btable_find"
                @row-selected="btable_rowSelected"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="btable_iconselected()"
                    aria-hidden="true"
                    @click="btable_iconselectedClick()"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        btable_rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in btable_rowActionCell(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="btable_rowClick(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="
                                    btable_rowActionIcon(action, row.item)
                                  "
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="btable_rowClick(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>

                <template v-slot:foot()="row">
                  <span
                    v-if="row.field.key == 'outstanding'"
                    class="strong text-primary"
                    >{{ balance | currency("") }}</span
                  >
                  <span v-else></span>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>

      <div v-if="component">
        <component
          :is="component"
          :selection="btable_selected"
          :config="cconfig"
          @saveit="saveit"
          @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"
        ></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3">
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary"
            >Found {{ btable_items.length }} rows</span
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import SLStatementEmail from "./Components/SLStatementEmail";
import SLStatementView from "./Components/SLStatementView";

export default {
  name: "SLStatements",
  components: { SLStatementEmail, SLStatementView },
  watch: {
    async transactiondate() {
      this.datefrom = this.transactiondate.startDate;
      this.dateto = this.transactiondate.endDate;
      await this.load();
    },

    async source() {
      if (this.source == "saracs_live") {
        this.datestatement = this.$moment().format("YYYY-MM-DD");
      } else {
        this.datestatement = this.$moment(this.source + "01", "YYYYMMDD")
          .endOf("month")
          .format("YYYY-MM-DD");
      }
      await this.load();
    },
    async statementtype() {
      await this.load();
    },
    async accounttype() {
      await this.load();
    },
    async slac() {
      await this.load();
    },
    async datestatement() {
      await this.load();
    },
    async status() {
      await this.load();
    },
    async datefrom() {
      if (this.datefrom && !this.dateto) {
        this.dateto = this.$moment().format("YYYY-MM-DD");
      }
      if (!this.datefrom) {
        this.dateto = null;
      }
      await this.load();
    },
    async dateto() {
      await this.load();
    },
    async query() {
      await this.load();
    },
  },
  data() {
    return {
      transactiondate: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },

      slac: null,
      datestatement: this.$moment().format("YYYY-MM-DD"),
      source: "saracs_live",
      statementtype: ["P"],
      status: "due",
      statementtype_options: null,
      accounttype: [],
      datefrom: null,
      dateto: null,
      accounttype_options: [],
      source_options: [{ id: "saracs_live", label: "saracs_live" }],
      status_options: [
        { id: "", label: "All" },
        { id: "due", label: "Due" },
        { id: "credit", label: "Credit" },
      ],
      query: "outstanding",
      query_options: [
        { id: "outstanding", label: "Outstanding" },
        { id: "invoiceonly", label: "Invoice Only" },
        { id: "creditonly", label: "Credit Only" },
      ],
      balance: 0,
      options: {
        title: "Statements",
        icon: "fa fa-university",
        debounce: 500,
        tools: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-search-plus",
            position: "toolbar",
            action: "view",
            label: "View",
            component: {
              name: "SLStatementView",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-envelope-o",
            position: "toolbar",
            action: "email",
            label: "Email",
            component: {
              name: "SLStatementEmail",
            },
          },
        ],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "to",
            label: "To",
            sortable: true,
            class: "text-center",
          },
          {
            key: "datelast",
            label: "Date Recent",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "outstanding",
            label: "Outstanding",
            sortable: true,
            class: "text-right",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        actions: [
          {
            key: "view",
            label: "View",
            icon: "fa fa-search-plus",
            single: true,
            multiple: false,
            component: {
              name: "SLStatementView",
            },
          },
          {
            key: "email",
            label: "Send Statement",
            icon: "fa fa-envelope-o",
            single: true,
            multiple: false,
            component: {
              name: "SLStatementEmail",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  async mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (this.user.permissions.includes("salesledger.admin")) {
      // this.options.actions
      //   .unshift
      // {
      //   key: "edit",
      //   label: "Edit",
      //   icon: "fa fa-pencil",
      //   single: true,
      //   multiple: true,
      //   component: {
      //     name: "SLItemEdit",
      //   },
      // }
      // {
      //   key: "invoice",
      //   label: "Invoice",
      //   icon: "fa fa-wpforms text-info",
      //   single: true,
      //   multiple: false,
      //   component: {
      //     name: "SLInvoiceEdit",
      //   },
      // },
      // {
      //   key: "credit",
      //   label: "Credit Note",
      //   icon: "fa fa-gbp text-danger",
      //   single: true,
      //   multiple: false,
      //   rule: "!credit",
      //   component: {
      //     name: "SLCreditItem",
      //   },
      // },
      // {
      //   key: "history",
      //   label: "History",
      //   icon: "fa fa-history text-warning",
      //   single: true,
      //   multiple: false,
      //   rule: "credit",
      // }
      // ();
    }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("edit,copy,add,import,archive");

    this.loadDDL();
  },

  methods: {
    async loadDDL() {
      console.log("loadDDL");

      try {
        const response = await this.$apollo.query({
          query: gql`
            query clientaccounttypes {
              clientaccounttypes {
                id
                label: name
              }
            }
          `,
        });
        this.accounttype_options = [...response.data.clientaccounttypes];
        for (var j = 0; j < this.accounttype_options.length; ++j) {
          if (!this.accounttype_options[j].label.includes("|")) {
            this.accounttype_options[j].label =
              this.accounttype_options[j].label +
              " | " +
              this.accounttype_options[j].id;
          }
        }
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query statementtypes {
              statementtypes {
                id
                label
              }
            }
          `,
        });
        this.statementtype_options = [];
        this.statementtype_options = response.data.statementtypes;
      } catch (error) {
        console.log(error);
      }

      this.source_options = [{ id: "saracs_live", label: "saracs_live" }];
      for (var k = 1; k < 13; k++) {
        this.source_options.push({
          id: this.$moment().subtract(k, "months").format("YYYYMM"),
          label: this.$moment().subtract(k, "months").format("YYYYMM"),
        });
      }
    },

    async load() {
      this.btable_items = [];

      this.btable_busy = true;

      let variables = {
        transactiondate: [this.datefrom, this.dateto],
        source: this.source,
        datestatement: this.datestatement,
        statementtype: this.statementtype ? this.statementtype.join(",") : null,
        accounttype:
          this.accounttype.length > 0 ? this.accounttype.join(",") : null,
        slac: this.slac ? this.slac.join(",") : null,
        status: this.status,
        trans_at: this.datefrom ? [this.datefrom, this.dateto] : null,
        query: this.query ? this.query : null,
        dateformat: "DD/MM/YYYY HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query statements(
              $source: String
              $statementtype: String
              $accounttype: String
              $datestatement: String
              $slac: String
              $status: String
              $trans_at: [String]
              $query: String
              $dateformat: String
            ) {
              statements(
                source: $source
                statementtype: $statementtype
                accounttype: $accounttype
                datestatement: $datestatement
                slac: $slac
                status: $status
                trans_at: $trans_at
                query: $query
                dateformat: $dateformat
              ) {
                id
                slac
                to
                outstanding
                datelast
              }
            }
          `,
          variables,
        });

        this.btable_items = response.data.statements;

        // COMPUTE FOOTER
        this.balance = 0;
        for (var j = 0; j < this.btable_items.length; ++j) {
          if (parseFloat(this.btable_items[j].outstanding) >= 0) {
            this.balance += parseFloat(this.btable_items[j].outstanding);
          } else {
            this.balance -= Math.abs(
              parseFloat(this.btable_items[j].outstanding)
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      switch (a) {
        case "notes":
        case "email":
        case "view":
          return this.btable_selected.length > 0 ? false : true;
      }
    },
  },
};
</script>

<style>
</style>